
import * as React from 'react';
import {useEffect} from "react";
import {SITE_MAINTENANCE} from "@bigyellow/routes";
import {site_under_maintenance} from "@bigyellow/api/customer";
import { redirect } from '@bigyellow/libs/redirect';

/**
 * redirects page to the maintenance page when ping fails
 */
const withMaintenanceRedirect = (Component) => (props) => {


    useEffect(()=>{
        const httpClient = props.store ? props.store.get('http_client') : null;
        if (props?.store) {
            site_under_maintenance(httpClient).catch(() => {

                redirect(SITE_MAINTENANCE);
            });
        }

    },[])


    return <Component {...props} />;
};

export default withMaintenanceRedirect;